<template>
    <div class="xc-page xc-page-sandwich">
        <div class="xc-page-main">
            <div class="xc-breadcrumb">
                <a href="">系统设置</a>
                <a href="">操作日志</a>
            </div>
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <form class="xc-form" name="search" @submit.prevent="search">
                            <div class="xc-form-inline">
                                <xc-form-item label="账号:" labelWidth="0">
                                    <input type="text" name="userName" v-model="mix_query.userName" class="xc-input" placeholder="请输入账号">
                                </xc-form-item>
                                <xc-form-item label="姓名:" labelWidth="0">
                                    <input type="text" name="realName" v-model="mix_query.realName" class="xc-input" placeholder="请输入姓名">
                                </xc-form-item>
                                <xc-form-item label="操作时间:" labelWidth="0">
                                    <input type="text" name="startTime" class="xc-input" placeholder="请输入开始时间" id="startTime" v-model="mix_query.startTime">
                                    至
                                    <input type="text" name="endTime" class="xc-input" placeholder="请输入结束时间" id="endTime" v-model="mix_query.endTime">
                                </xc-form-item>
                                <xc-form-item label="IP地址:" labelWidth="0">
                                    <input type="text" name="ip" v-model="mix_query.ip" class="xc-input" placeholder="请输入账号IP地址">
                                </xc-form-item>
                                <div class="xc-btn-group">
                                    <button type="submit" class="xc-btn xc-btn-primary">查询</button>
                                </div>
                            </div>
                        </form>
                        <div class="xc-row-scroll">
                            <table class="xc-table">
                                <thead>
                                    <tr>
                                        <th>序号</th>
                                        <th>账号</th>
                                        <th>姓名</th>
                                        <th>IP地址</th>
                                        <th>最后操作时间</th>
                                        <th>操作内容</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="list && list.length">
                                        <tr v-for="(item,index) in list" :key="index">
                                            <td>
                                                {{index+1}}
                                            </td>
                                            <td>
                                                {{item.userName}}
                                            </td>
                                            <td>
                                                {{item.realName}}
                                            </td>
                                            <td>
                                                {{item.ip}}
                                            </td>
                                            <td>
                                                {{item.operationTime}}
                                            </td>
                                            <td class="desc" :title="item.operationContent" style="text-align: left;">
                                                {{item.operationContent}}
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <td colspan="20" class="xc-s-tac">暂无数据</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="xc-page-footer">
            <!-- 分页 -->
            <xc-pagination @change="mix_pageChange" :page="mix_page" :total="mix_total" :size="mix_pageSize" />
        </div>
    </div>
</template>

<script>
import listMixin from '../xc-ui/mixins/list';
import '@/libs/flatpickr';
import setting from "@/api/sysconfig"
import '@/utils/ip-format';

export default {
    name: 'departmentList',
    mixins: [listMixin],
    data() {
        return {
            // 列表key
            mix_listKey: 'list',

            // 列表唯一字段
            mix_listId: 'operationLogId',

            list: [],

            // 默认查询参数
            mix_query: {
                realName:"",
                userName:"",
                ip:"",
                startTime:"",
                endTime:""
            },
            modalName: null,  //弹窗名称,add表示添加\edit表示编辑
            current: null,   //当前表行
        }
    },
    computed: {

    },
    methods: {
        //查询
        search: function () {
            this.mix_search();
        },
        // 初始化数据
        initData() {
            var _this=this;
            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query,
            }

            //请求操作日志
            setting.getLog(search).then(function (ret) {
                //添加mix_checkbox属性
                _this.list = _this.mix_format(ret.data.list);
                _this.mix_total = ret.data.total;
                _this.mix_page = ret.data.pageNum;
                _this.mix_pageSize = ret.data.pageSize;
            }).catch(function (error) {
                console.log(error)
            })
        },
    },
    created() {
        var _this = this;
        //汉化
        // flatpickr.localize(flatpickr.l10ns.zh);
        //初始化时间选择
        this.$nextTick(function () {
            document.getElementById("startTime").flatpickr({
                enableTime: false,
                maxDate: new Date(),
                onChange: function (date, str, instance) {
                    _this.$nextTick(function () {
                        if (_this.mix_query.startTime && _this.mix_query.endTime && _this.mix_query.endTime < _this.mix_query.startTime) {
                            _this.$message.error("开始时间不能大于结束时间");
                            instance.clear();
                            return;
                        }
                    })
                },
            });
            document.getElementById("endTime").flatpickr({
                enableTime: false,
                maxDate: new Date(),
                onChange: function (date, str, instance) {
                    _this.$nextTick(function () {
                        if (_this.mix_query.startTime && _this.mix_query.endTime && _this.mix_query.endTime < _this.mix_query.startTime) {
                            _this.$message.error("结束时间不能小于开始时间");
                            instance.clear();
                            return;
                        }
                    })
                }
            });
        })
    }
}
</script>

<style scoped lang="scss">
    .desc{
        max-width: 20em;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .search-line {
        list-style-type: none;
    }

    .search-line .search-list {
        float: left;
        margin: 0px 25px 25px 0px;
    }

    .null-box {
        clear: both;
    }
</style>
